import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function ReinitialiserMotDePasse() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("Le mot de passe doit faire au moins 8 caractères.");
      return;
    }
    if (password !== confirm) {
      toast.error("Les deux mots de passe ne correspondent pas.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      toast.success(data.message || "Mot de passe réinitialisé.");
      navigate("/connexion");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] px-6 py-20">
      <div className="mx-auto max-w-md">
        <Link to="/" className="inline-block">
          <Logo className="h-20" />
        </Link>
        <h1 className="mt-12 text-4xl font-extrabold tracking-tighter">Nouveau mot de passe</h1>
        {!token ? (
          <div data-testid="reset-no-token" className="mt-10 rounded-2xl border border-red-200 bg-red-50 p-6 text-sm text-red-700">
            <p className="font-semibold">Lien invalide.</p>
            <p className="mt-2">Ce lien de réinitialisation est incomplet ou a expiré.</p>
            <Link to="/mot-de-passe-oublie" className="mt-4 inline-block font-semibold text-brand underline underline-offset-4">
              Refaire une demande
            </Link>
          </div>
        ) : (
          <>
            <p className="mt-3 text-neutral-500">Choisissez un nouveau mot de passe (8 caractères minimum).</p>
            <form onSubmit={submit} className="mt-10 space-y-4">
              <input
                data-testid="reset-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Nouveau mot de passe"
                className="w-full rounded-lg border border-neutral-300 bg-white px-4 py-3 outline-none focus:border-brand transition-colors"
              />
              <input
                data-testid="reset-confirm-input"
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Confirmer le mot de passe"
                className="w-full rounded-lg border border-neutral-300 bg-white px-4 py-3 outline-none focus:border-brand transition-colors"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="reset-submit-btn"
                className="w-full rounded-full bg-brand px-6 py-4 font-bold text-white transition-colors hover:bg-brand-hover disabled:opacity-60"
              >
                {loading ? "Validation…" : "Réinitialiser mon mot de passe"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
